import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TEACHER_DEFAULT_PASSCODE } from "../local/customLessons";
import { getRememberedClassCode, rememberClassCode } from "../classroom/types";

/** Class entry — students type/confirm the class code; teacher enters via passcode. */
export function ClassEntry() {
  const nav = useNavigate();
  const [code, setCode] = useState(getRememberedClassCode());
  const [teacher, setTeacher] = useState(false);
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");

  const joinStudent = (e: React.FormEvent) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (c.length < 3) return;
    rememberClassCode(c);
    nav(`/class/login?code=${c}`);
  };
  const teacherEnter = (e: React.FormEvent) => {
    e.preventDefault();
    if (pass.trim() === TEACHER_DEFAULT_PASSCODE) nav("/class/host");
    else setErr("Wrong passcode.");
  };

  return (
    <div className="class-entry">
      <h1 className="class-entry-title">🎓 Class</h1>
      {!teacher ? (
        <>
          <form onSubmit={joinStudent} className="class-entry-form">
            <label>Class code</label>
            <input className="class-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="CODE" maxLength={6} autoFocus />
            <button className="btn btn-green btn-big btn-block" type="submit" disabled={code.trim().length < 3}>Join class →</button>
          </form>
          <button className="btn btn-ghost" onClick={() => setTeacher(true)}>👩‍🏫 I'm the teacher</button>
          <button className="btn btn-ghost" onClick={() => nav("/")}>← Menu</button>
        </>
      ) : (
        <form onSubmit={teacherEnter} className="class-entry-form">
          <label>Teacher passcode</label>
          <input className="class-code-input" type="password" value={pass} onChange={(e) => setPass(e.target.value)} autoFocus />
          {err && <p className="class-err">{err}</p>}
          <button className="btn btn-green btn-big btn-block" type="submit">Enter →</button>
          <button className="btn btn-ghost" type="button" onClick={() => setTeacher(false)}>← Back</button>
        </form>
      )}
    </div>
  );
}
